<script setup lang="ts">
  import { onMounted, ref } from 'vue';
  import { fetchMedia } from '@/shared/lib';
  import { DSCVR_STATIC_ASSETS_CDN_URL } from '@/common';
  import type { dscvrApi } from '@/shared/api';
  import { animateLootboxItem } from '../util';
  import SolanaLootIcon from '../ui/SolanaLootIcon.vue';

  const props = defineProps<{
    lootboxItem: dscvrApi.lootbox.ILootboxItem;
  }>();

  const tokenDisplay = ref<HTMLImageElement>();

  onMounted(() => {
    if (!props.lootboxItem.isClaimed && tokenDisplay.value) {
      animateLootboxItem(tokenDisplay.value);
    }
  });
</script>

<template>
  <div>
    <solana-loot-icon class="absolute top-6 left-6 z-40" />
    <img
      v-if="lootboxItem"
      v-lazy="{
        src: lootboxItem.token.image,
        error: fetchMedia(
          `${DSCVR_STATIC_ASSETS_CDN_URL}/solana/missing-nft.jpg`,
        ),
      }"
      :alt="lootboxItem.token.name"
      class="aspect-square"
      ref="tokenDisplay"
    />
    <h3 class="flex py-6 pl-4 text-base font-semibold text-white gap-x-2">
      <span class="mr-2">{{ lootboxItem.token.name }} </span>
    </h3>
  </div>
</template>
